<template>
  <div class="wrapper-full">
    <div class="titlebar-container border-bottom-thin">
      <div class="detect-container" v-show="!isHasUrl">
        <el-button
          class="btn-oprator border-normal"
          v-if="isTopographyEnabled"
          @click="showCapture('topography')"
        >
          <span class="label iconfont icon-camera"></span>&nbsp;&nbsp;
          <span class="label">{{ $t("langcfg.txtTopography") }}</span>
        </el-button>
        <el-button
          class="btn-oprator border-normal"
          v-if="isDryEyeEnabled"
          @click="showCapture('dryeye')"
        >
          <span class="label iconfont icon-camera"></span>&nbsp;&nbsp;
          <span class="label">{{ $t("langcfg.txtDryEye") }}</span>
        </el-button>
      </div>
      <div class="patient-record-cotainer">
        <DataTable
          :dispH="dispH - 180"
          :tableData="records"
          :headers="recordHeaders"
          :currentIndex="currentIndex"
          @pulling-down="pullingDown"
          @pulling-up="pullingUp"
          @cell-click="deleteRecord"
          @row-click="enterRecord"
        />
      </div>
    </div>
    <div class="mw-mask" @click="$emit('show-record-disabled-tip')" v-if="isMaskVisible"></div>
  </div>
</template>
<script>
import DataTable from "./basic/DataTable";
import { Message, Size, License } from "../../mixins";
import { recordHeaders } from "../../services/record";
import { isDefined, getSystemTime } from "../../shared/utils";
import { mapState } from "vuex";
import home from "../../store/modules/home";
import { DRYEYEMODES } from "../../shared/consts";
import fileSys from "../../fileoprators/fileSystem";
export default {
  name: "RecordList",
  data() {
    return {
      search: "",
      record: [],
      recordHeaders: recordHeaders.concat()
    };
  },
  mixins: [Message, Size, License],
  props: {
    records: {
      type: Array,
      default: () => {
        return [];
      }
    },
    currentRecord: {
      type: Object,
      default: () => {
        return {};
      }
    },
    isMaskVisible: {
      type: Boolean,
      default: false
    }
  },
  components: {
    DataTable
  },
  methods: {
    showCapture(checktype) {
      if (checktype === "dryeye") {
        this.$emit("enter-qN", (record) => {
          this.$emit("show-capture", checktype, DRYEYEMODES.questionnaire.key);
        });
      } else {
        this.$emit("show-capture", checktype);
      }
    },
    deleteRecord(record) {
      this.$emit("delete-reocrd", record, true);
    },
    pullingDown(callback) {
      setTimeout(() => {
        callback();
      }, 2000);
    },
    pullingUp(callback) {
      setTimeout(() => {
        callback();
      }, 2000);
    },
    enterRecord(rec) {
      this.$emit("enter-record", rec);
    }
  },
  computed: {
    ...mapState({
      isHasUrl: (state) => home.state.isHasUrl
    }),
    tableWith() {
      return `${this.dispW}px`;
    },
    capSpan() {
      return this.isTopographyEnabled && this.isDryEyeEnabled ? 12 : 24;
    },
    tableHeight() {
      return `${this.dispH}px`;
    },
    currentIndex() {
      if (isDefined(this.currentRecord)) {
        for (let id = 0; id < this.records.length; id++) {
          if (this.currentRecord._id === this.records[id]._id) {
            return id;
          }
        }
      }
      return 0;
    }
  }
};
</script>
<style lang="less" scoped>
.detect-container {
  height: 100%;
  display: flex;
  align-items: center;
  padding-left: 10px;
  padding-right: 10px;

  & > .el-button {
    flex: 1;
  }

  .label {
    font-size: 30px;
  }
  .btn-oprator:hover {
    .label {
      color: @btn-hover-color;
    }
  }
  .btn-oprator {
    height: @header-fs+20px;
  }
}

.input {
  font-size: @header-fs;
}

.record-list-mask {
  position: absolute;
  width: 100%;
  height: 100%;
}
.patient-record-cotainer {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/RecordList.vue